import React, { useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import BookingOverView from './BookingOverView';
import UpcomingSchedules from './UpcomingSchedules';
import Widgets from './Widgets';
import BookingStatus from './BookingStatus';
import UpcomingStatus from './UpcomingStatus';
import Section from './Section';

const DashboardProject = () => {
  const [bookingCount2, setBookingCount2] = useState("");

  // Shared Filter States
  const [startDate1, setStartDate1] = useState("");
  const [endDate1, setEndDate1] = useState("");
  const [selectedCar, setSelectedCar] = useState("");

  const setBookingCount1 = (count) => {
    setBookingCount2(count);
  };

  document.title = "LimoGenie - Booking Dashboard";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xxl={12}>
              <Section
                setBookingCount1={setBookingCount1}
                startDate1={startDate1}
                setStartDate1={setStartDate1}
                endDate1={endDate1}
                setEndDate1={setEndDate1}
                selectedCar={selectedCar}
                setSelectedCar={setSelectedCar}
              />
            </Col>
          </Row>
          <Row className="project-wrapper">
            <Col xxl={8}>
              <Widgets bookingCount1={bookingCount2} />
              <BookingOverView
                startDate={startDate1}
                endDate={endDate1}
                selectedCar={selectedCar}
              />
            </Col>
            <UpcomingSchedules />
          </Row>
          <Row>
            <BookingStatus
              startDate={startDate1}
              endDate={endDate1}
              selectedCar={selectedCar}
            />
            <UpcomingStatus />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardProject;